import { Injectable } from '@angular/core';

import { PermissionLevel } from './permission';
import { Observable } from 'rxjs';
import { Role } from '../../user-management/users/role';

@Injectable()
export class PermissionService {
  private permissionLevel: PermissionLevel;
  private _userRights: Role[];

  public changePermissionLevel(permissionLevel: PermissionLevel): void {
    this.permissionLevel = permissionLevel;
  }

  public hasAccess(permissionLevel: PermissionLevel): boolean {
    if (!!this.permissionLevel) {
      return this.permissionLevel <= permissionLevel;
    } else {
      return false;
    }
  }

  public clearPermission(): void {
    this.permissionLevel = null;
  }

  public hasPermissionLevel(): boolean {
    return !!this.permissionLevel;
  }

  public isEmployee(): boolean {
    return this.permissionLevel === PermissionLevel.EMPLOYEE;
  }

  public isAdmin(): boolean {
    return this.permissionLevel === PermissionLevel.ADMIN;
  }

  public isManager(): boolean {
    return this.permissionLevel === PermissionLevel.MANAGER;
  }

  public accessibleMainRoutes(routes: any): Observable<any>[] {
    const routes$: Observable<any>[] = [];
    routes.forEach(route => {
      if (this.hasMainRouteAccessRight(route)) {
        routes$.push(route.routes$);
      }
    });
    return routes$;
  }

  public hasMainRouteAccessRight(route: any): boolean {
    if (route.associatedRightName === null) {
      return true;
    }
    const right = this._userRights.find(
      (role: Role) =>
        role.name === route.associatedRightName ||
        (Array.isArray(route.associatedRightName) &&
          route.associatedRightName.includes(role.name))
    );

    if (route.everyAssociatedRightName) {
      if (!Array.isArray(route.everyAssociatedRightName)) {
        return false;
      }

      const everyRight = route.everyAssociatedRightName.every(rightName =>
        this._userRights.some(role => role.name === rightName)
      );
      return everyRight;
    }

    return !right ? false : right.checked;
  }

  set userRights(userRights: Role[]) {
    this._userRights = userRights;
  }
}
